<template>
    <ul style="list-style: none; color: darkblue;font-weight: bolder">
        <li  @click="dataBack(breadCrumb[0])">
            {{ breadCrumb[0].title }}
        </li>
        <li v-if="breadCrumb.length>1">
            <recursive-component :data-back="dataBack" :bread-crumb="breadCrumb.slice(1,breadCrumb.length)"></recursive-component>
        </li>
    </ul>
</template>

<script>
export default {
    name: "recursiveComponent",
    props: {
        breadCrumb: {
            default: () => {
                return [];
            }
        },
        dataBack:{
            require:true
        }
    }
}
</script>

<style scoped>
li>ul{
    padding-right: 3rem;
    list-style: none;
}
</style>